export default __webpack_public_path__ + "static/media/nzfs-icon.33be0045.svg";